/**
 * Appends `video_consent` to SAP navigation params so `useInitialDraft` can capture the
 * checkbox's state at the moment the user continues.
 */
export function appendVideoConsentToSapParams(params: URLSearchParams, videoConsent: boolean): void {
	params.set('video_consent', String(videoConsent));
}
